import { render } from "./ClientNotes.vue?vue&type=template&id=9b09ad74&scoped=true"
import script from "./ClientNotes.vue?vue&type=script&lang=js"
export * from "./ClientNotes.vue?vue&type=script&lang=js"

import "./ClientNotes.vue?vue&type=style&index=0&id=9b09ad74&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b09ad74"]])

export default __exports__